import { forwardRef } from 'react';
import styled from 'styled-components';
import { Tabs as BaseTabs, TabsProps } from '@mui/material';
import { radius, space } from '../../style/utils';

type StyledProps = {
  $indicatorBorder?: boolean;
  $allowScroll?: boolean;
};

type Props = TabsProps & {
  indicatorBorder?: boolean;
  allowScroll?: boolean;
};

const StyledTabs = styled(BaseTabs)<StyledProps>`
  width: ${({ orientation }) => (orientation !== 'vertical' ? 'auto' : '100%')};

  &.MuiTabs-root {
    min-height: 0;
  }

  & .MuiTab-root {
    padding: ${({ orientation }) =>
      orientation !== 'vertical' ? space('lg') : space('sm', 'lg')};
    margin-left: 0;
    border-left: ${({ theme, $indicatorBorder }) =>
      $indicatorBorder && `2px solid ${theme.palette.border.subtle}`};
    min-height: 0;
    height: ${({ orientation }) => orientation === 'vertical' && '35px'};
    :hover {
      border-radius: ${({ orientation }) =>
        orientation === 'vertical' && radius(0, 'md', 'md', 0)};
    }
  }

  & .MuiTabs-indicator {
    background-color: ${({ theme }) => theme.palette.surface.inverse};
    height: 2px;
    ${({ orientation }) => orientation === 'vertical' && 'left: 0'};
  }

  & .MuiTabs-scroller {
    ${({ $allowScroll }) => $allowScroll && 'overflow-y: auto !important'};
  }
`;

const Tabs = forwardRef<HTMLDivElement, Props>(
  ({ indicatorBorder, allowScroll, ...props }, ref) => (
    <StyledTabs
      ref={ref}
      $indicatorBorder={indicatorBorder}
      $allowScroll={allowScroll}
      {...props}
    />
  ),
);

export default Tabs;
